module.exports = __webpack_public_path__ + "static/media/엽서섬네일 (11).5fc15077.PNG";